<script setup>
</script>

<template>
  <v-card class="livery-skeleton-card" width="310">
    <!-- Image skeleton -->
    <div class="skeleton-image">
      <Skeletor width="100%" height="174px" />
    </div>

    <!-- Info sections skeleton -->
    <div class="skeleton-content">
      <!-- Livery name -->
      <div class="skeleton-item">
        <Skeletor width="100%" height="40px" />
      </div>

      <!-- Car name -->
      <div class="skeleton-item">
        <Skeletor width="100%" height="40px" />
      </div>

      <!-- Code -->
      <div class="skeleton-item">
        <Skeletor width="100%" height="40px" />
      </div>

      <!-- Author -->
      <div class="skeleton-item">
        <Skeletor width="100%" height="40px" />
      </div>
    </div>
  </v-card>
</template>

<style scoped>
.livery-skeleton-card {
  background: var(--primary-color);
  margin: 25px;
  border-radius: 8px;
  overflow: hidden;
}

.skeleton-image {
  width: 100%;
  margin: 6px;
  width: calc(100% - 12px);
  border-radius: 4px;
  overflow: hidden;
}

.skeleton-content {
  padding: 0 6px 6px 6px;
}

.skeleton-item {
  margin-bottom: 6px;
  border-radius: 4px;
  overflow: hidden;
}

.skeleton-item:last-child {
  margin-bottom: 0;
}
</style>
